<style src="../assets/estilo-dashboard.css"></style>
<style src="../assets/estilo-dashboard-2.css"></style>
   
<template>
    <v-container>
        <!--v-layout align-center justify-center-->
        <v-layout align-center justify-center>
            <v-loading class="loading" v-model="loading" v-if="loading">
    
                <v-progress-circular persistent
                :size="70"
                :width="7"
                color="primary"
                indeterminate
                ></v-progress-circular>
        
            </v-loading>
            <v-flex xs12 sm12 md12>
                <!--v-card class="elevation-12"-->
                    <v-toolbar dark color="primary">
                        <v-toolbar-title><a href="javascript:history.back()" class="voltar"><img class="imgVoltar" :src="imgVoltar"></a>Dashboard da escola</v-toolbar-title>
                    </v-toolbar><br />

                    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                        <div class="md-card md-theme-default">
                            <div class="md-card-header card-chart" @click="usuariosEscolaFn" data-background-color="blue">
                                <div id="div_1113761961257" class="ct-chart">
                                    <img :src="imgUsuarios">
                                </div>
                            </div>
                            <div class="md-card-content">
                                <h4 @click="usuariosEscolaFn" class="title">Usuários</h4>
                                <p class="category">Quantidade de usuários da escola</p>
                            </div>
                            <!-- <div class="md-card-actions md-alignment-left">
                                <div class="stats">
                                    <i class="md-icon md-icon-font md-theme-default">access_time</i>
                                    updated 10 days ago
                                </div>
                            </div> -->
                        </div>
                    </div>

                    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                        <div class="md-card md-theme-default">
                            <div class="md-card-header card-chart" @click="engajamentoFn" data-background-color="green">
                                <div id="div_1113761961257" class="ct-chart">
                                    <img :src="imgEngajamento">
                                </div>
                            </div>
                            <div class="md-card-content">
                                <h4 @click="engajamentoFn" class="title">Engajamento</h4>
                                <p class="category">Usuários mais engajados</p>
                            </div>
                            <!-- <div class="md-card-actions md-alignment-left">
                                <div class="stats">
                                    <i class="md-icon md-icon-font md-theme-default">access_time</i>
                                    updated 10 days ago
                                </div>
                            </div> -->
                        </div>
                    </div>

                    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                        <div class="md-card md-theme-default">
                            <div class="md-card-header card-chart" @click="ocorrencias" data-background-color="red">
                                <div id="div_1113761961257" class="ct-chart">
                                    <img :src="imgOcorrencias">
                                </div>
                            </div>
                            <div class="md-card-content">
                                <h4 @click="ocorrencias" class="title">Ocorrências</h4>
                                <p class="category">Lista de ocorrência</p>
                            </div>
                            <!-- <div class="md-card-actions md-alignment-left">
                                <div class="stats">
                                    <i class="md-icon md-icon-font md-theme-default">access_time</i>
                                    updated 10 days ago
                                </div>
                            </div> -->
                        </div>
                    </div>

                    
                
            </v-flex>
            
        </v-layout>

        

        <v-dialog v-model="dialogUsuariosEscola" max-width="100%">
            
            <v-card>
                
                <v-card-title class="headline">Usuários por perfil</v-card-title>
                
                <v-card-text>
                    <v-layout row wrap>
                        <a class="closeModal" @click="closeModal">x</a>
                        
                    </v-layout>


                    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
                        <div class="md-card md-card-stats md-theme-default">
                            <div class="md-card-header" data-background-color="blue">
                                <i class="material-icons dp48">apartment</i>
                            </div>
                            <div class="md-card-content">
                                <p class="category">Usuários</p>
                                <h3 class="title">{{usuariosEscola}}</h3>
                            </div>
                            <div class="md-card-actions md-alignment-left">
                                <div class="stats">
                                    <!-- <i class="md-icon md-icon-font md-theme-default">Perfil: </i> -->
                                    Escola
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
                        <div class="md-card md-card-stats md-theme-default">
                            <div class="md-card-header" data-background-color="green">
                                <i class="material-icons dp48">streetview</i>
                            </div>
                            <div class="md-card-content">
                                <p class="category">Usuários</p>
                                <h3 class="title">{{usuariosAdministrativo}}</h3>
                            </div>
                            <div class="md-card-actions md-alignment-left">
                                <div class="stats">
                                    <!-- <i class="md-icon md-icon-font md-theme-default">Perfil:</i> -->
                                    Administrativo
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
                        <div class="md-card md-card-stats md-theme-default">
                            <div class="md-card-header" data-background-color="purple">
                                <i class="material-icons dp48">people</i>
                            </div>
                            <div class="md-card-content">
                                <p class="category">Usuários</p>
                                <h3 class="title">{{usuariosAdministrativoProfessor}}</h3>
                            </div>
                            <div class="md-card-actions md-alignment-left">
                                <div class="stats">
                                    <!-- <i class="md-icon md-icon-font md-theme-default">Perfil:</i> -->
                                    Administrativo/Professor
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
                        <div class="md-card md-card-stats md-theme-default">
                            <div class="md-card-header" data-background-color="red">
                                <i class="material-icons dp48">school</i>
                            </div>
                            <div class="md-card-content">
                                <p class="category">Usuários</p>
                                <h3 class="title">{{usuariosProfessor}}</h3>
                            </div>
                            <div class="md-card-actions md-alignment-left">
                                <div class="stats">
                                    <!-- <i class="md-icon md-icon-font md-theme-default">Perfil:</i> -->
                                    Professor
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
                        <div class="md-card md-card-stats md-theme-default">
                            <div class="md-card-header" data-background-color="yellow">
                                <i class="material-icons dp48">face</i>
                            </div>
                            <div class="md-card-content">
                                <p class="category">Usuários</p>
                                <h3 class="title">{{usuariosPais}}</h3>
                            </div>
                            <div class="md-card-actions md-alignment-left">
                                <div class="stats">
                                    <!-- <i class="md-icon md-icon-font md-theme-default">Perfil:</i> -->
                                    Responsáveis
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
                        <div class="md-card md-card-stats md-theme-default">
                            <div class="md-card-header" data-background-color="orange">
                                <i class="material-icons dp48">child_care</i>
                            </div>
                            <div class="md-card-content">
                                <p class="category">Usuários</p>
                                <h3 class="title">{{usuariosAlunos}}</h3>
                            </div>
                            <div class="md-card-actions md-alignment-left">
                                <div class="stats">
                                    <!-- <i class="md-icon md-icon-font md-theme-default">Perfil:</i> -->
                                    Aluno
                                </div>
                            </div>
                        </div>
                    </div>

                </v-card-text>
                <v-card-actions>
                    

                
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" style="position:absolute; right: 0; bottom:6px;" flat @click="closeModal">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>







        <v-dialog v-model="dialogOcorrencias" max-width="100%">
            <v-card>
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                <v-toolbar-title>Ocorrências {{nomeAluno}}</v-toolbar-title>
                <v-card-text>
                    <label class="v-label theme--light">Ano:</label>
                    <v-flex xs12 sm12 md12>
                        <v-card-text style="padding:0 0 0 0; width:100%"> 
                            <v-select
                                :items="itemsAnos"
                                item-value="value.ID"
                                item-text="value.label"
                                return-object
                                v-model="anos"
                                v-on:change="changeYear"
                            ></v-select>
                        </v-card-text>
                    </v-flex><br />

                    <label class="v-label theme--light">Mês:</label>
                    <v-flex xs12 sm12 md12>
                        <v-card-text style="padding:0 0 0 0; width:100%"> 
                            <v-select
                                :items="itemsMeses"
                                item-value="value.ID"
                                item-text="value.label"
                                return-object
                                v-model="meses"
                                v-on:change="changeMonth"
                            ></v-select>
                        </v-card-text>
                    </v-flex><br />
                    
                    <v-card>
                    
                    
                        <!--v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" :disabled="!valid" @click="submit" data-cy="joinSubmitBtn">Cadastrar</v-btn>
                            <v-btn color="primary" :disabled="!valid || !statusUpload" @click="atualizarResumoDiario" data-cy="joinSubmitBtn">Atualizar</v-btn>
                        </v-card-actions-->
                    </v-card>
                        <a class="closeModal" @click="closeModal">x</a>
                        <div>
                            <v-radio-group row wrap style="display:none">
                            <v-switch v-model="alignTop" label="Toggle align-top" class="mx-4"></v-switch>
                            <v-switch v-model="dense" label="Toggle dense" class="mx-4"></v-switch>
                            <v-switch v-model="fillDot" label="Toggle fill-dot" class="mx-4"></v-switch>
                            <v-switch v-model="hideDot" label="Toggle hide-dot" class="mx-4"></v-switch>
                            <v-switch v-model="icon" label="Toggle icon" class="mx-4"></v-switch>
                            <v-switch v-model="avatar" label="Toggle avatar" class="mx-4"></v-switch>
                            <v-switch v-model="iconColor" label="Toggle icon color" class="mx-4"></v-switch>
                            <v-switch v-model="reverse" label="Toggle reverse" class="mx-4"></v-switch>
                            <v-switch v-model="left" label="Toggle left" class="mx-4"></v-switch>
                            <v-switch v-model="right" label="Toggle right" class="mx-4"></v-switch>
                            <v-switch v-model="small" label="Toggle small" class="mx-4"></v-switch>
                            </v-radio-group>

                            <div id="chart" v-if="resumo == true">
                                <apexchart type=pie width=380 :options="chartOptions" :series="series" />
                            </div>
                            <br /><br />
                            <h2 v-if="resumo == true">Timeline</h2>
                            <v-timeline
                            :align-top="alignTop"
                            :dense="dense"
                            :reverse="reverse"
                            v-if="resumo == true">
                            <v-timeline-item v-for="(item, index) in objTimeline"
                                :key="n"
                                :fill-dot="fillDot"
                                :hide-dot="hideDot"
                                :icon="icon ? 'mdi-star' : ''"
                                :icon-color=" iconColor ? 'deep-orange' : ''"
                                :left="left"
                                :right="right"
                                :small="small"
                            >
                                <template v-slot:icon>
                                <v-avatar>
                                    <img :src="img1" v-if="item.rating == 1">
                                    <img :src="img2" v-if="item.rating == 2">
                                    <img :src="img3" v-if="item.rating == 3">
                                    <img :src="img4" v-if="item.rating == 4">
                                    <img :src="img5" v-if="item.rating == 5">
                                </v-avatar>
                                </template>
                                <v-card class="elevation-2">
                                <v-card-title class="headline" style="margin-bottom:0; padding-bottom:0">{{item.data}}</v-card-title>
                                <v-card-text style="margin-top:0; padding-top:0" :v-if="item.observacao != ''">
                                    {{item.observacao}}
                                </v-card-text>
                                </v-card>
                            </v-timeline-item>
                            </v-timeline>
                        </div>

                    </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>


                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="closeModal">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>









        <v-dialog v-model="dialogEngajamento" max-width="100%">
            <v-card>
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                <v-toolbar-title>Engajamento dos responsáveis</v-toolbar-title>
                <v-card-text>
                    <label class="v-label theme--light">Ano:</label>
                    <v-flex xs12 sm12 md12>
                        <v-card-text style="padding:0 0 0 0; width:100%"> 
                            <v-select
                                :items="itemsAnos"
                                item-value="value.ID"
                                item-text="value.label"
                                return-object
                                v-model="anos"
                                v-on:change="changeYear2"
                            ></v-select>
                        </v-card-text>
                    </v-flex><br />

                    <label class="v-label theme--light">Mês:</label>
                    <v-flex xs12 sm12 md12>
                        <v-card-text style="padding:0 0 0 0; width:100%"> 
                            <v-select
                                :items="itemsMeses"
                                item-value="value.ID"
                                item-text="value.label"
                                return-object
                                v-model="meses"
                                v-on:change="changeMonth2"
                            ></v-select>
                        </v-card-text>
                    </v-flex><br />
                    
                    <v-card>
                        
                    
                    </v-card>
                        <a class="closeModal" @click="closeModal">x</a>
                        <div>
                            <v-flex v-for="(item, index) in maisEngajados" xs12 sm12 md12 row class="usuariosListagem">
                            
                                <img class="imagem" v-bind:style="{ 'background-image': 'url(' + item.img + ')' }" />
                                <div><b>{{item.nome}}</b></div>
                                <div>Pontos: {{item.pontos}}</div>
                                <div>Posição: {{index + 1}}</div>
                                
                            </v-flex>
                        </div>
                    </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>


                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="closeModal">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
    </v-container>
</template>

<script>
import Vue from 'vue'
import db from './firebaseInit';
import firebase,{ storage } from 'firebase';

import {mask} from 'vue-the-mask';

import { userProperties, usersData } from '@/global.js';

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
 
Vue.component('apexchart', VueApexCharts)


import img1 from '../assets/muito-feliz.png';
import img2 from '../assets/feliz.png';
import img3 from '../assets/normal.png';
import img4 from '../assets/ruim.png';
import img5 from '../assets/muito-ruim.png';

import imgOcorrencias from '../assets/ic-ocorrencias.png';
import imgUsuarios from '../assets/ic-usuarios.png';
import imgEngajamento from '../assets/ic-engajamento.png';

import imgVoltar from '../assets/ic-voltar.png';

var now = new Date();
var year = "" + now.getFullYear();
var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }

export default {
    name: 'Dashboard-Escola',
    components: {
        apexchart: VueApexCharts,
    },
    directives: {mask},
    data: vm => ({
        imgVoltar: imgVoltar,
        imgOcorrencias: imgOcorrencias,
        imgUsuarios: imgUsuarios,
        imgEngajamento: imgEngajamento,
        img1: img1,
        img2: img2,
        img3: img3,
        img4: img4,
        img5: img5,
        //varivaveis da timeline
        alignTop: true,
        avatar: false,
        dense: true,
        fillDot: false,
        hideDot: false,
        icon: false,
        iconColor: false,
        left: false,
        reverse: false,
        right: true,
        small: false,
        anoSelecionado: year,
        mesSelecionado: month,
        engajamento: false,
        maisEngajados: null,
        anos: {
            value: {
                ID: year,
                label: year
            }//,
        //text: '2018'
        },
        itemsAnos: [
            {
                value: {
                    ID: '2018',
                    label: '2018'
                }//,
                //text: '2018'
            },
            {
                value: {
                    ID: '2019',
                    label: '2019'
                }
                //text: '2019'
            },
            {
                value: {
                    ID: '2020',
                    label: '2020'
                }
                //text: '2019'
            }
        ],
        meses: {
            value: {
                ID: month
            }//,
        //text: '2018'
        },
        itemsMeses: [
            {
                value: {
                    ID: '00',
                    label: 'Todos'
                }
            },
            {
                value: {
                    ID: '01',
                    label: 'Janeiro'
                }
            },
            {
                value: {
                    ID: '02',
                    label: 'Fevereiro'
                }
            },
            {
                value: {
                    ID: '03',
                    label: 'Março'
                }
            },
            {
                value: {
                    ID: '04',
                    label: 'Abril'
                }
            },
            {
                value: {
                    ID: '05',
                    label: 'Maio'
                }
            },
            {
                value: {
                    ID: '06',
                    label: 'Junho'
                }
            },
            {
                value: {
                    ID: '07',
                    label: 'Julho'
                }
            },
            {
                value: {
                    ID: '08',
                    label: 'Agosto'
                }
            },
            {
                value: {
                    ID: '09',
                    label: 'Setembro'
                }
            },
            {
                value: {
                    ID: '10',
                    label: 'Outubro'
                }
            },
            {
                value: {
                    ID: '11',
                    label: 'Novembro'
                }
            },
            {
                value: {
                    ID: '12',
                    label: 'Dezembro'
                }
            }
        ],

        objTimeline: [],
        rating: null,
        executaUmaVez: 0,
        valid: false,
        loading: false,
        dialogUsuariosEscola: false,
        dialogOcorrencias: false,
        dialogEngajamento: false,
        tituloModal: "Selecione o período!",
        menu: false,
        chartsLib: null,
        date: new Date().toISOString().substr(0, 10),
        dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
        licaoCasa: false,
        pushIDs: null,
        banho: false,
        textoPush: null,
        entrada: null,
        saida: null,
        horasSono: null,
        
        //dash usuarios
        usuariosEscola: 0,
        usuariosAdministrativoProfessor: 0,
        usuariosAdministrativo: 0,
        usuariosProfessor: 0,
        usuariosPais: 0,
        usuariosAlunos: 0,

        nomeAluno: null,
                evacuacao: {
                        value: {
                            evacuacaoID: 0,
                            evacuacaoName: 'Nenhuma vez'
                        }
                    },
                itemsEvacuacao: [
                    {
                        value: {
                            evacuacaoID: 0,
                            evacuacaoName: 'Nenhuma vez' // Aparece na timeline e na listagem
                        },
                        text: 'Nenhuma vezv'
                    },
                    {
                        value: {
                            evacuacaoID: 1,
                            evacuacaoName: 'Um vez' // Aparece na timeline e na listagem
                        },
                        text: 'Um vez'
                    },
                    {
                        value: {
                            evacuacaoID: 2,
                            evacuacaoName: 'Duas vezes' // Aparece na timeline e na listagem
                        },
                        text: 'Duas vezes'
                    },
                    {
                        value: {
                            evacuacaoID: 3,
                            evacuacaoName: 'Três vezes' // Aparece na timeline e na listagem
                        },
                        text: 'Três vezes'
                    }
                    ,
                    {
                        value: {
                            evacuacaoID: 4,
                            evacuacaoName: 'Mais de 3 vezes' // Aparece na timeline e na listagem
                        },
                        text: 'Mais de 3 vezes'
                    }
                ],
                cafeManha: {
                    value: {
                        cafeManhaID: 0,
                        cafeManhaName: 'Não'
                    }
                },
                itemsCafeManha: [
                    {
                        value: {
                            cafeManhaID: 0,
                            cafeManhaName: 'Não' // Aparece na timeline e na listagem
                        },
                        text: 'Não'
                    },
                    {
                        value: {
                            cafeManhaID: 1,
                            cafeManhaName: 'Sim' // Aparece na timeline e na listagem
                        },
                        text: 'Sim'
                    }
                ],
                almoco: {
                    value: {
                        almocoID: 0,
                        almocoName: 'Não'
                    }
                },
                itemsAlmoco: [
                    {
                        value: {
                            almocoID: 0,
                            almocoName: 'Não'
                        },
                        text: 'Não'
                    },
                    {
                        value: {
                            almocoID: 1,
                            almocoName: 'Sim'
                        },
                        text: 'Sim'
                    }
                ],
                cafeTarde: {
                    value: {
                        cafeTardeID: 0,
                        cafeTardeName: 'Não'
                    }
                },
                itemsCafeTarde: [
                    {
                        value: {
                            cafeTardeID: 0,
                            cafeTardeName: 'Não' 
                        },
                        text: 'Não'
                    },
                    {
                        value: {
                            cafeTardeID: 1,
                            cafeTardeName: 'Sim'
                        },
                        text: 'Sim'
                    }
                ],
                janta: {
                    value: {
                        jantaID: 0,
                        jantaName: 'Não'
                    }
                },
                itemsJanta: [
                    {
                        value: {
                            jantaID: 0,
                            jantaName: 'Não' 
                        },
                        text: 'Não'
                    },
                    {
                        value: {
                            jantaID: 1,
                            jantaName: 'Sim'
                        },
                        text: 'Sim'
                    }
                ],
                aluno: {
                        alunoSlug: '',
                        alunoName: ''
                },
                itemsAlunos: [
                    // {
                    //         alunoSlug: 0,
                    //         alunoName: 'Laura'
                    // },
                    // {
                    //         alunoSlug: 1,
                    //         alunoName: 'Alice'
                    // }
                ],
                resumo: false,
                otimo: 0,
                bom: 0,
                normal: 0,
                ruim: 0,
                regular: 0,
                series: [44, 55, 13, 43, 22],
                colors: ['#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800'],
                chartOptions: {
                    labels: ['Resolvido', 'Resolvido Parcialmente', 'Não Resolvido'],
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 300
                            },
                            legend: {
                                position: 'bottom'
                                
                            }
                        }
                    }]
                }
        
    }),
    methods: { // ####################### Criar parte que criar documentos collections de cada escola ao realizar primeiro login do usuario Escola
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${month}/${day}/${year}`
        },
        parseDate (date) {
            if (!date) return null

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        changeYear(selected){
            console.log("Ano Selecionado = " + selected.value.ID);
            this.anoSelecionado = selected.value.ID;
            this.ocorrencias();
        },
        changeMonth(selected){
            console.log("Mes Selecionado = " + selected.value.ID);
            this.mesSelecionado = selected.value.ID;
            if(selected.value.label == "Todos"){
                this.ocorrenciasTodos();
            }                
            else{
                this.ocorrencias();
            }
        },
        changeYear2(selected){
            console.log("Ano Selecionado = " + selected.value.ID);
            this.anoSelecionado = selected.value.ID;
            this.engajamentoFn();
        },
        changeMonth2(selected){
            console.log("Mes Selecionado = " + selected.value.ID);
            this.mesSelecionado = selected.value.ID;
            if(selected.value.label == "Todos"){
                this.engajamentoFnTodos();
            }                
            else{
                this.engajamentoFn();
            }
        },
        engajamentoFn(){

            // Google Analytics - Events
            gtag('event', 'clicou', {
                'event_category': 'dashboard escola',
                'event_label': 'engajamento'//,
                //'value': '<value>'
            });

            this.dialogEngajamento = true;
            this.loading = true;
            var maisEngajadosSemFoto = [];
            var maisEngajados = [];
            var contador = 0;

            // Ordenar exibicao -0 numerica
            function ordenarPorPontuacao(a, b){
                //return a.pontos - b.pontos; // crescente
                return b.pontos - a.pontos; // decrescente
            }

            var listaSlugUsuarios = [];
            usersData.usuarios.forEach((item, index) => {
                if(item.perfil == 6){
                    listaSlugUsuarios.push({"slug": item.slug, "extensao": item.extensao, "nome": item.nome})
                }
            });

            var logs = []
            db.collection('log_'+userProperties.escolaID).where("ano", "==", this.anoSelecionado).where("mes", "==", this.mesSelecionado)
            .get()
            .then((querySnapshot) => {
                if(querySnapshot.size == 0){
                    this.maisEngajados = [];
                    this.loading = false;
                    alert("Não possui registro nesse período.")
                }
                else{
                    querySnapshot.forEach(doc => {
                        // doc.data() is never undefined for query doc snapshots
                        console.log(doc.id, " => ", doc.data());       
                        let customObj = doc.data()
                        logs.push(customObj)
                        
                    });

                    
                    
                    var urlImg;
                    listaSlugUsuarios.forEach((item, index) => {
                        logs.forEach((item2, index) => {
                            if(item2.slugAutor == item.slug){
                                contador = Number(contador) + Number(item2.pontos);
                            }
                        });
                        
                        maisEngajadosSemFoto.push({"slug": item.slug, "extensao": item.extensao, "nome": item.nome, "pontos": contador})

                        contador = 0;
                        
                        
                        
                    });

                    maisEngajadosSemFoto.forEach((item3, index3) => {
                        var storageRef = firebase.storage().ref();
                        var tangRef = storageRef.child('profile/'+item3.slug+'.'+item3.extensao);

                    // First we sign in the user anonymously
                    //firebase.auth().signInAnonymously().then((result) => {
                    // Once the sign in completed, we get the download URL of the image
                        tangRef.getDownloadURL().then(urlImgFB =>                             {
                        // Once we have the download URL, we set it to our img element
                        //console.log(urlImgFB);
                        urlImg = urlImgFB;
                        
                            maisEngajados.push({"slug": item3.slug, "extensao": item3.extensao, "nome": item3.nome, "pontos": item3.pontos,"img": urlImg})
                        
                        contador = 0
                        this.loading = false;

                        // ordenar exibicao - numerica
                        maisEngajados.sort(ordenarPorPontuacao);
                        this.maisEngajados = maisEngajados;
                        
                        }).catch((error) => {
                            // If anything goes wrong while getting the download URL, log the error,
                            console.error(error);
                            this.loading = false;
                            contador = 0;
                        });
                    });

                    

                        

                    // ordenar exibicao - numerica
                    maisEngajados.sort(ordenarPorPontuacao);
                    this.maisEngajados = maisEngajados;
                }
                
            })
            .catch((err) => {
                console.log("ERRO AO CONSULTAR DADOS DE ENGAJAMENTO: ", err);
                this.resumo = false;
                alert("ERRO AO CONSULTAR DADOS DE ENGAJAMENTO.")
            })
        },
        diarioPorData(){

            // Google Analytics - Events
            gtag('event', 'clicou', {
                'event_category': 'dashboard escola',
                'event_label': 'ocorrencias'//,
                //'value': '<value>'
            });

            this.menu = false;
            var that = this;
            this.loading = true;

            // Busca nome pelo Slug
            //var responsaveisDoAlunoSlug = [];
            usersData.usuarios.forEach((item, index) => {
                if(item.slug == this.$route.query.slug){
                    this.nomeAluno = item.nome;
                }
            });

            db.collection('ocorrencias').where("escolaID", "==", userProperties.escolaID).where("ano", "==", this.anoSelecionado).where("mes", "==", this.mesSelecionado)
            .get()
            .then((querySnapshot) => {
                if(querySnapshot.size == 0){
                    this.resumo = false
                    alert("A escola não possui registro de ocorrência nesse período.")
                }
                else{
                    querySnapshot.forEach(doc => {
                        // doc.data() is never undefined for query doc snapshots
                        console.log(doc.id, " => ", doc.data());       
                        let customObj = doc.data()
                        this.date = customObj.date,
                        this.entrada = customObj.entrada,
                        this.saida = customObj.saida,
                        this.horasSono = customObj.horasSono,
                        this.evacuacao = {
                            value: {
                                evacuacaoID: customObj.evacuacaoID,
                                evacuacaoName: customObj.evacuacaoName
                            }
                        },
                        // this.evacuacao.value.evacuacaoName = customObj.evacuacaoName,
                        // this.evacuacao.value.evacuacaoID = customObj.evacuacaoID,
                        this.cafeManha = {
                            value: {
                                cafeManhaID: customObj.cafeManhaID,
                                cafeManhaName: customObj.cafeManhaName
                            }
                        },
                        // this.cafeManha.value.cafeManhaName = customObj.cafeManhaName,
                        // this.cafeManha.value.cafeManhaID = customObj.cafeManhaID,
                        this.almoco = {
                            value: {
                                almocoID: customObj.almocoID,
                                almocoName: customObj.almocoName
                            }
                        },
                        // this.almoco.value.almocoName = customObj.almocoName,
                        // this.almoco.value.almocoID = customObj.almocoID,
                        this.cafeTarde = {
                            value: {
                                cafeTardeID: customObj.cafeTardeID,
                                cafeTardeName: customObj.cafeTardeName
                            }
                        },
                        // this.cafeTarde.value.cafeTardeName = customObj.cafeTardeName,
                        // this.cafeTarde.value.cafeTardeID = customObj.cafeTardeID,
                        this.janta = {
                            value: {
                                jantaID: customObj.jantaID,
                                jantaName: customObj.jantaName
                            }
                        },
                        // this.janta.value.jantaName = customObj.jantaName,
                        // this.janta.value.jantaID = customObj.jantaID,
                        this.licaoCasa = customObj.licaoCasa,
                        this.banho = customObj.banho,
                        this.rating = customObj.rating,
                        this.aluno = customObj.aluno,
                        this.alunoName = "customObj.alunoName"
                    });
                    this.resumo = true
                }
                that.executaUmaVez = 0;
                setTimeout(function(){ 
                    
                    $(".custom-rating a").click(function(){
                        if(that.executaUmaVez == 0){
                            $(".custom-rating a").removeClass("selected");
                            $(this).addClass("selected");
                            that.executaUmaVez = 1;
                        }
                    })    
                    // Marca carinha/rating selecionada
                    var itemRating = Number(that.rating) - 1;
                    $(".custom-rating a:eq("+itemRating+")").click();    

                }, 500);

                this.loading = false;
                
            })
            .catch((err) => {
                console.log("ERRO AO CONSULTAR DIÁRIO: ", err);
                this.resumo = false;
                alert("Erro ao consultar diário.")
            })

        },
        closeModal(){
            this.dialogUsuariosEscola = false;
            this.dialogOcorrencias = false;
            this.dialogEngajamento = false;
            this.loading = false;
        },
        onChartReady (chart, google) {
            this.chartsLib = google
        },
        usuariosEscolaFn(){

            // Google Analytics - Events
            gtag('event', 'clicou', {
                'event_category': 'dashboard escola',
                'event_label': 'usuarios da escola'//,
                //'value': '<value>'
            });

            this.dialogUsuariosEscola = true;

            var escola = 0;
            var administrativoProfessor = 0;
            var administrativo = 0;
            var professor = 0;
            var pais = 0;
            var alunos = 0;

            usersData.usuarios.forEach((item, index) => {
                if(item.perfil == 2){
                    escola = escola + 1
                }
                else if(item.perfil == 3){
                    administrativoProfessor = administrativoProfessor + 1
                }
                else if(item.perfil == 4){
                    administrativo = administrativo + 1
                }
                else if(item.perfil == 5){
                    professor = professor + 1
                }
                else if(item.perfil == 6){
                    pais = pais + 1
                }
                else if(item.perfil == 7){
                    alunos = alunos + 1
                }
            });

            this.usuariosEscola = escola;
            this.usuariosAdministrativoProfessor = administrativoProfessor;
            this.usuariosAdministrativo = administrativo;
            this.usuariosProfessor = professor;
            this.usuariosPais = pais;
            this.usuariosAlunos = alunos;
        },
        ocorrencias(){
            this.dialogOcorrencias = true;
            this.loading = true;
            this.resumo = false;

            this.objTimeline = [];

            // ordernar exibicao - numerica
            function ordenarPorTimestamp(a, b){
                //return a.dataNumero - b.dataNumero; // crescente
                return b.dataNumero - a.dataNumero; // decrescente
            }

            db.collection('ocorrencias').where("escolaID", "==", userProperties.escolaID).where("ano", "==", this.anoSelecionado).where("mes", "==", this.mesSelecionado)
            .get()
            .then((querySnapshot) => {
                if(querySnapshot.size == 0){
                    this.resumo = false
                    alert("A escolha não possui registro de ocorrência nessa data.")
                }
                else{
                    var resolvido = 0; // 1
                    var resolvidoParcialmente = 0; // 3
                    var naoResolvido = 0; // 5
                    querySnapshot.forEach(doc => {
                        // doc.data() is never undefined for query doc snapshots
                        console.log(doc.id, " => ", doc.data());       
                        
                        let customObj = doc.data()
                        this.date = customObj.date,
                        this.rating = customObj.rating
                        if(customObj.rating == 1){
                            resolvido = resolvido + 1
                        }
                        if(customObj.rating == 3){
                            resolvidoParcialmente = resolvidoParcialmente + 1
                        }
                        if(customObj.rating == 5){
                            naoResolvido = naoResolvido + 1
                        }
                        this.objTimeline.push({"data":customObj.date.substring(8,10) + "-" + customObj.date.substring(5,7) + "-" + customObj.date.substring(0,4), "rating":customObj.rating, "dataNumero":customObj.date.replace(/-/g, ''), "observacao":customObj.observacao})
                    });
                    this.resolvido = resolvido; // 1
                    this.resolvidoParcialmente = resolvidoParcialmente; // 3
                    this.naoResolvido = naoResolvido; // 5

                    this.resumo = true;

                    this.series = [this.resolvido, this.resolvidoParcialmente, this.naoResolvido];
                }

                this.objTimeline.sort(ordenarPorTimestamp)

                this.loading = false;
            
            })
            .catch((err) => {
                console.log("ERRO AO CONSULTAR DIÁRIO: ", err);
                this.loading = false;
                this.resumo = false;
                alert("Erro ao consultar diário.")
            })
        },
        ocorrenciasTodos(){
            this.dialogOcorrencias = true;
            this.loading = true;
            this.resumo = false;

            this.objTimeline = [];

            // ordernar exibicao - numerica
            function ordenarPorTimestamp(a, b){
                //return a.dataNumero - b.dataNumero; // crescente
                return b.dataNumero - a.dataNumero; // decrescente
            }

            db.collection('ocorrencias').where("escolaID", "==", userProperties.escolaID).where("ano", "==", this.anoSelecionado)
            .get()
            .then((querySnapshot) => {
                if(querySnapshot.size == 0){
                    this.resumo = false
                    alert("A escola não possui registro de ocorrência nessa data.")
                }
                else{
                    var resolvido = 0; // 1
                    
                    var resolvidoParcialmente = 0; // 3
                    
                    var naoResolvido = 0; // 5

                    querySnapshot.forEach(doc => {
                        // doc.data() is never undefined for query doc snapshots
                        console.log(doc.id, " => ", doc.data());       
                        
                        let customObj = doc.data()
                        this.date = customObj.date,
                        this.rating = customObj.rating
                        if(customObj.rating == 1){
                            resolvido = resolvido + 1
                        }
                        if(customObj.rating == 3){
                            resolvidoParcialmente = resolvidoParcialmente + 1
                        }
                        if(customObj.rating == 5){
                            naoResolvido = naoResolvido + 1
                        }
                        this.objTimeline.push({"data":customObj.date.substring(8,10) + "-" + customObj.date.substring(5,7) + "-" + customObj.date.substring(0,4), "rating":customObj.rating, "dataNumero":customObj.date.replace(/-/g, ''), "observacao":customObj.observacao})
                    });
                    this.resolvido = resolvido; // 1
                    this.resolvidoParcialmente = resolvidoParcialmente; // 3
                    this.naoResolvido = naoResolvido; // 5

                    this.resumo = true;

                    this.series = [this.resolvido, this.resolvidoParcialmente, this.naoResolvido];
                }

                this.objTimeline.sort(ordenarPorTimestamp)

                this.loading = false;
            
            })
            .catch((err) => {
                console.log("ERRO AO CONSULTAR DIÁRIO: ", err);
                this.loading = false;
                this.resumo = false;
                alert("Erro ao consultar diário.")
            })
        }
        
    },
    mounted() {
        
        // Log do sistema
        if(userProperties.escolaID != null){            
            // timestamp
            var now = new Date();
            var year = "" + now.getFullYear();
            var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
            var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
            var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
            var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
            var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
            //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
            var customtimestamp = year + month + day + hour + minute + second

            db.collection('log_' + userProperties.escolaID).add({
                    escolaID: userProperties.escolaID,
                    slugAutor: userProperties.slug,
                    perfil: userProperties.perfil,
                    
                    //slug: this.slug,
                    customtimestamp: customtimestamp,
                    dia: day,
                    mes: month,
                    ano: year,
                    acao: "acessar",
                    categoria: "dashboard",
                    pontos: 4
                    
                })
                .then(docRef => {
                    console.log('Document written with ID: ', docRef.id);

                    
                })
                .catch(function (error) {
                    console.log('Error adding document: ', error);
                    console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                })
        }
        else{
            alert("Sua sessão expirou, você será redirecionado para reautenticar!");
            this.$router.push(`/`);
        };
    }
    
    
        
};
</script>

<style scoped>
    .loading{
        position: absolute;
        top:20%;
        left:42%;
        z-index: 2;
    }

    .container{
        padding: 0 1px !important;
    }

    .buttonOk{
        position: absolute;
        right: 2px;
        bottom: 5px;
    }

    .btCirculo{
        height: 30px;
        width: 30px;
    }

    .btCirculo a{
        color:#fff;
    }

    progress{
        width:100%;
        margin-top: 6px;
    }

    label.v-label.theme--light{
        margin-bottom: 6px;
        display: block
    }

    .v-card.v-sheet.theme--light{
        float: left;
        width: 100%;
    }

    .usuariosListagem{
        float: left;
        width: 100%;
        display: block;
        clear: both;
        margin-top: 15px;
        margin-bottom: 5px;
    }
    .usuariosListagem .imagem{
        width: 80px;
        height: 80px;
        margin-right: 12px;
        border: beige solid 1px;
        border-radius: 50%;
        background-position: center center;
        background-size: 100% auto;
        position: relative;
        top: -8px;
        float: left;
    }

    .adicionarItem.btCirculo{
        position: relative;
        top: 12px;
        left: 5px;
    }

    .excluirItem.btCirculo{
        position: relative;
        left: 5px;
        top:-10px;
    }

    .box-items-selecionados{
        background: silver;
        width: 100%;
        padding: 20px 5px 5px 10px;
    }

    .container{
        padding: 0 0 !important;
    }

    .grid-list-sm img{
        width: 70%;
        height: auto !important;
    }

    .grid-list-sm a{
        min-height: 70px;
    }

    a.selected img{
        width: 100%;
        height: auto !important;
        cursor: pointer;
    }

    .label-rating{
        display: block;
        text-align: center
    }

    a.closeModal{
        color: #000;
        position: absolute;
        right: 14px;
        top: 4px;
        font-size: 16px
    }

    .v-avatar{
        position: absolute;
        left: -70px;
        top: 0px;
    }

    h3 i{
        font-size: 40px;
        position: relative;
        top: 12px;
        margin-right: 8px;
    }

    .ct-chart{
        text-align: center
    }

    .ct-chart img{
        width:50%;
        margin:15px auto 6px auto;
    }


    
</style>
